// Detect whether the current runtime is the Capacitor native app (iOS/Android)
// as opposed to a plain browser visit to erasmusswap.com. All app-only UI
// (bottom tab bar, onboarding auto-redirect, mobile gradient hero, etc.)
// gates on this so the website keeps its original layout intact.

export function isNativeApp() {
    if (typeof window === "undefined") return false;
    try {
        // Capacitor injects window.Capacitor on native platforms.
        const cap = window.Capacitor;
        if (cap && typeof cap.isNativePlatform === "function") {
            return cap.isNativePlatform();
        }
        if (cap && cap.platform && cap.platform !== "web") return true;
    } catch { /* ignore */ }
    return false;
}
